const MembersStyles = theme => ({
  searchContainer: {
    paddingBottom: 40,
    marginRight: 5,
    [theme.breakpoints.down('xs')]: {
      marginRight: 0
    }
  },
  searchWithGroups: {
    [theme.breakpoints.down('xs')]: {
      paddingBottom: 10
    }
  },
  groupsSelectContainer: {
    marginBottom: 10,
  },
  groupsContainer: {
    paddingBottom: 10
  },
  emptyListView: {
    fontSize: '20px',
    textAlign: 'center',
    marginTop: 60,
    width: '100%'
  },
  pinnedMembers: {
    marginBottom: 10
  }
});

export default MembersStyles;
